// src/icons/GoTwoTone.tsx
import { useTheme } from "@emotion/react";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function GoTwoTone() {
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "24", height: "24", fill: theme.hcNeutral }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.20792 11.1836C4.17676 11.1836 4.16897 11.168 4.18455 11.1447L4.34813 10.9343C4.36371 10.911 4.40266 10.8954 4.43382 10.8954H7.21476C7.24592 10.8954 7.25371 10.9188 7.23813 10.9421L7.1057 11.1447C7.09012 11.168 7.05118 11.1914 7.02781 11.1914L4.20792 11.1836Z",
            fill: theme.bg
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.03116 11.9003C3 11.9003 2.99221 11.8847 3.00779 11.8613L3.17137 11.651C3.18695 11.6276 3.2259 11.6121 3.25706 11.6121H6.80919C6.84035 11.6121 6.85593 11.6354 6.84814 11.6588L6.78582 11.8458C6.77803 11.8769 6.74687 11.8925 6.71571 11.8925L3.03116 11.9003Z",
            fill: theme.bg
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.9169 12.6171C4.88574 12.6171 4.87795 12.5937 4.89353 12.5703L5.00259 12.3756C5.01817 12.3522 5.04933 12.3289 5.08049 12.3289H6.63844C6.6696 12.3289 6.68517 12.3522 6.68517 12.3834L6.6696 12.5703C6.6696 12.6015 6.63844 12.6249 6.61507 12.6249L4.9169 12.6171Z",
            fill: theme.bg
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.0035 11.0434C12.5128 11.168 12.1778 11.2615 11.6948 11.3862C11.578 11.4173 11.5702 11.4251 11.4689 11.3083C11.3521 11.1758 11.2664 11.0901 11.1028 11.0122C10.6121 10.7707 10.1369 10.8409 9.69287 11.1291C9.16316 11.4719 8.89052 11.9782 8.89831 12.6092C8.9061 13.2324 9.33454 13.7465 9.94993 13.8322C10.4796 13.9023 10.9236 13.7154 11.2742 13.3181C11.3443 13.2324 11.4066 13.1389 11.4845 13.0299C11.2041 13.0299 10.8535 13.0299 9.98109 13.0299C9.8175 13.0299 9.77855 12.9286 9.83308 12.7962C9.93435 12.5547 10.1213 12.1496 10.2304 11.947C10.2537 11.9003 10.3083 11.8224 10.4251 11.8224H13.2606C13.245 12.0327 13.245 12.2431 13.2138 12.4534C13.1281 13.0143 12.9178 13.5284 12.5751 13.9802C12.0142 14.7203 11.282 15.1799 10.355 15.3046C9.5916 15.4058 8.88273 15.2578 8.25955 14.7904C7.68311 14.3542 7.35594 13.7777 7.27025 13.061C7.16899 12.2119 7.41826 11.4485 7.93238 10.7785C8.48545 10.0541 9.21769 9.59445 10.1135 9.43086C10.8457 9.29843 11.5468 9.38412 12.1778 9.81257C12.5907 10.0852 12.8867 10.4591 13.0814 10.911C13.1281 10.9811 13.097 11.02 13.0035 11.0434Z",
            fill: theme.bg
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.582 15.3513C14.8731 15.3357 14.2266 15.1332 13.6813 14.6658C13.2217 14.2685 12.9335 13.7621 12.84 13.1623C12.6998 12.282 12.9413 11.503 13.471 10.8097C14.0396 10.0619 14.7251 9.67236 15.6521 9.50877C16.4467 9.36855 17.1945 9.44645 17.8722 9.90606C18.4876 10.3267 18.8693 10.8954 18.9705 11.6432C19.103 12.6949 18.7992 13.5518 18.0747 14.2841C17.5606 14.806 16.9296 15.1332 16.2052 15.2812C15.9949 15.3201 15.7845 15.3279 15.582 15.3513ZM17.436 12.2041C17.4282 12.1029 17.4282 12.025 17.4126 11.9471C17.2724 11.1758 16.5635 10.7396 15.8235 10.911C15.099 11.0746 14.6317 11.5342 14.4603 12.2664C14.3201 12.8741 14.6161 13.4895 15.1769 13.7388C15.6054 13.9257 16.0338 13.9024 16.4467 13.692C17.0621 13.3726 17.397 12.8741 17.436 12.2041Z",
            fill: theme.bg
          }
        )
      ]
    }
  );
}

export {
  GoTwoTone
};
